import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Sizes } from './constants';

const emptyCell = '-';
const RegionalSizes = ({ showEmptyCells, region }) => {
  return (
    <tr>
      <td>
        <FormattedMessage id="interactiveSizeGuide.table.size" />
      </td>
      {region.sizes.map(s => (
        <td key={s}>{showEmptyCells ? emptyCell : s}</td>
      ))}
    </tr>
  );
};

const BodySize = ({ showEmptyCells, bodySizeMessage, unitMessage, sizes }) => (
  <tr>
    <td>
      <FormattedMessage
        id={bodySizeMessage}
        values={{ 0: showEmptyCells ? emptyCell : <FormattedMessage id={unitMessage} /> }}
      />
    </td>
    {sizes?.map(h => (
      <td key={h}>{showEmptyCells ? emptyCell : h}</td>
    ))}
  </tr>
);

const BodySizes = ({ silhouette, showEmptyCells, measurementSystem }) => {
  const { waist, hips, bust } = measurementSystem.sizes;
  return (
    <>
      {silhouette.code !== 'jogger' && (
        <BodySize
          sizes={bust}
          showEmptyCells={showEmptyCells}
          bodySizeMessage="interactiveSizeGuide.table.bust"
          unitMessage={measurementSystem.abbrev}
        />
      )}
      <BodySize
        sizes={waist}
        showEmptyCells={showEmptyCells}
        bodySizeMessage="interactiveSizeGuide.table.waist"
        unitMessage={measurementSystem.abbrev}
      />
      <BodySize
        sizes={hips}
        showEmptyCells={showEmptyCells}
        bodySizeMessage="interactiveSizeGuide.table.hips"
        unitMessage={measurementSystem.abbrev}
      />
    </>
  );
};

const Table = ({ silhouette, showEmptyTable, selectedRegion, measurementSystem }) => {
  return (
    <div className="interactive-size-guide__table-container">
      <table className={`interactive-size-guide__table ${showEmptyTable ? 'isOpen' : ''}`}>
        <thead>
          <tr>
            <th />
            {Sizes.map(s => (
              <th key={s}>{s}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          <RegionalSizes showEmptyCells={showEmptyTable} region={selectedRegion} />
          <BodySizes silhouette={silhouette} showEmptyCells={showEmptyTable} measurementSystem={measurementSystem} />
        </tbody>
      </table>
    </div>
  );
};

export default Table;
